// @flow
import RefreshToken from './RefreshToken';

type Session = {
  refreshToken: RefreshToken;
}

export { RefreshToken };
export type { Session };



// WEBPACK FOOTER //
// ./src/common/modules/session/domain/Session.js